import { VideoRepresentation } from '../types';

export const getIsVideoPasswordPresent = (video: VideoRepresentation) =>
  !!video.privacy_settings?.password_protected;
